import axios from "../utils/axios.wrapper";

export const getBankAccounts = async () => {
  const { data } = await axios.get("/bankAccount");
  return data.items || data;
};

export const getBankAccountById = async (id) => {
  const { data } = await axios.get(`/bankAccount/${id}`);
  return data;
};

export const createBankAccount = async (bankAccount) => {
  const { data } = await axios.post("/bankAccount/create", bankAccount);
  return data;
};

export const updateBankAccount = async (id, bankAccount) => {
  const { data } = await axios.put(`/bankAccount/${id}`, bankAccount);
  return data;
};

export const deleteBankAccount = async (id) => {
  const { data } = await axios.delete(`/bankAccount/soft/${id}`);
  return data;
};

export const bankAccountService = {
  getBankAccounts,
  getBankAccountById,
  createBankAccount,
  updateBankAccount,
  deleteBankAccount,
};